<template>
  <div class="magazine-edition">
    <navigator :items="items"></navigator>
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="card">
            <b-tabs card>
              <b-tab title="Cadastro" active>
                <div class="container-fluid">
                  <div class="row">
                    <div class="col-12">
                      <div class="title-section">Dados da edição</div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12">
                      <div class="form-group">
                        <label for>
                          Revista
                          <span class="required-field">*</span>
                        </label>
                        <select
                          class="form-control"
                          v-model="edition.magazine_id"
                          v-on:change="verifyEditionMagazine()"
                        >
                          <option
                            v-for="item in createParams.magazines"
                            :value="item.id"
                            v-bind:key="item.id"
                          >{{item.name}}</option>
                        </select>
                      </div>
                    </div>
                    <div class="col-lg-3 col-12">
                      <div class="form-group">
                        <label for>
                          Ano
                          <span class="required-field">*</span>
                        </label>
                        <input v-model="edition.year" type="number" min="0" class="form-control" />
                      </div>
                    </div>
                    <div class="col-lg-3 col-12">
                      <div class="form-group">
                        <label for>
                          Mês
                          <span class="required-field">*</span>
                        </label>
                        <select v-model="edition.month" class="form-control">
                          <option value="1">Janeiro</option>
                          <option value="2">Fevereiro</option>
                          <option value="3">Março</option>
                          <option value="4">Abril</option>
                          <option value="5">Maio</option>
                          <option value="6">Junho</option>
                          <option value="7">Julho</option>
                          <option value="8">Agosto</option>
                          <option value="9">Setembro</option>
                          <option value="10">Outubro</option>
                          <option value="11">Novembro</option>
                          <option value="12">Dezembro</option>
                        </select>
                      </div>
                    </div>
                    <div class="col-lg-2 col-12">
                      <div class="form-group">
                        <label for>
                          Nº da edição
                          <span class="required-field">*</span>
                        </label>
                        <input
                          v-model="edition.edition_number"
                          v-on:change="verifyEditionMagazine()"
                          type="number"
                          min="0"
                          class="form-control"
                        />
                      </div>
                    </div>
                    <div class="col-lg-4 col-12">
                      <div class="form-group">
                        <label for style="color: transparent">Placeholder</label>
                        <div class="d-flex align-items-center justify-content-end toggle-input">
                          <label for>
                            Edição publicada no site
                            <span class="required-field">*</span>
                          </label>
                          <toggle-button
                            v-model="edition.is_published"
                            v-bind:key="edition.is_published"
                          />
                        </div>
                      </div>
                    </div>
                    <div
                      class="col-12"
                      v-bind:class="{'col-lg-9':edition.digital_version_url, 'col-lg-12': !edition.digital_version_url}"
                    >
                      <div class="form-group">
                        <label for>Versão digital (PDF)</label>
                        <b-form-file
                          placeholder="Escolha um arquivo"
                          drop-placeholder="Arraste o arquivo aqui..."
                          browse-text="Procurar"
                          accept="application/pdf"
                          v-on:change="uploadFile"
                        ></b-form-file>
                      </div>
                    </div>
                    <div class="col-3" v-if="edition.digital_version_url">
                      <div
                        class="w-100 h-100 d-flex-align-items-center justify-content-end"
                        style="padding-top: 32px;"
                      >
                        <a
                          :href="edition.digital_version_url"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <button class="btn btn-primary float-right">Ver versão atual</button>
                        </a>
                      </div>
                    </div>
                    <!-- <div
                      class="col-lg-5 col-12 d-flex justify-content-between"
                      style="margin-bottom: 12px"
                    >
                      <button
                        class="btn btn-primary"
                        v-on:click="generateAuthorLetters()"
                      >Gerar carta aos autores</button>
                      <button class="btn btn-primary">Gerar etiquetas</button>
                    </div>-->
                  </div>
                  <div class="row">
                    <div class="col-12">
                      <button class="btn btn-primary float-right" v-on:click="save()">Salvar</button>
                    </div>
                  </div>
                </div>
              </b-tab>
              <b-tab title="Conteúdo" :disabled="formType == 'create'">
                <magazine-edition-texts v-if="edition.id" :magazine_edition_id="edition.id"></magazine-edition-texts>
              </b-tab>
              <b-tab
                title="Carta para os autores"
                :disabled="formType == 'create'"
                v-on:click="generateAuthorLetters()"
              >
                <text-editor-component :textContent="authorsLetter" :height="editorHeight"></text-editor-component>
              </b-tab>
              <b-tab
                title="Etiquetas"
                :disabled="formType == 'create'"
                v-on:click="generateAuthorTags()"
              >
                <text-editor-component :textContent="authorsTag" :height="editorHeight"></text-editor-component>
              </b-tab>
            </b-tabs>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "@/api/axios";
import edition_validate from "@/imports/validator/models/edition";
import validator from "@/imports/validator/validate";
import MagazineEditionTexts from "@/components/magazine_edition/MagazineEditionTexts";
import TextEditorComponent from "@/components/inputs/TextEditorComponent";
import Swal from "sweetalert2";
import { bus } from "@/main";

export default {
  name: "magazine-edition",
  components: {
    TextEditorComponent,
    MagazineEditionTexts
  },
  props: {
    id: Number
  },
  data() {
    return {
      edition: {},
      createParams: {},
      editorHeight: 800,
      authorsLetter: "",
      authorsTag: "",
      tempFile: "",
      formType: "create",
      items: [
        {
          text: "Edições",
          route: "admin.editions"
        },
        {
          text: "Novo Edição",
          active: true
        }
      ]
    };
  },
  mounted() {
    this.getCreateParams();
    if (this.id) {
      this.formType = "edit";
      this.getDataObject(this.id);
    }
  },
  methods: {
    getDataObject: function(id) {
      axios
        .get(`${process.env.VUE_APP_API_HOST}/api/magazine_editions/${id}`)
        .then(response => {
          this.edition = response.data;
          this.items[1].text = `${
            this.edition.magazine.name
          } - ${this.getMonthLabel(this.edition.month)} ${
            this.edition.year
          } - nº ${this.edition.edition_number}`;
          bus.$emit("changeLoading", false);
        });
    },
    uploadFile: function(e) {
      const file = e.target.files[0];
      if (!file.type.includes("/pdf")) {
        Swal.fire({
          title: "Arquivo não suportado",
          icon: "error"
        });
        return;
      }
      if (typeof FileReader === "function") {
        const reader = new FileReader();
        reader.onload = event => {
          this.tempFile = event.target.result;
        };
        reader.readAsDataURL(file);
      }
    },
    getCreateParams: function() {
      bus.$emit("changeLoading", true);
      axios
        .get(`${process.env.VUE_APP_API_HOST}/api/magazine_editions/create`)
        .then(data => {
          this.createParams = data.data;
          bus.$emit("changeLoading", false);
        });
    },
    verifyEditionMagazine: function() {
      if (this.edition.magazine_id && this.edition.edition_number) {
        axios
          .get(
            `${process.env.VUE_APP_API_HOST}/api/unique_version_magazine?magazine_id=${this.edition.magazine_id}&edition_number=${this.edition.edition_number}`
          )
          .then(response => {
            if (response.data.exists == 1) {
              Swal.fire({
                title: "Parece que essa edição já existe",
                icon: "info"
              });
              this.edition.edition_number = null;
            }
          });
      }
    },
    save: function() {
      let errors = validator.validate(this.edition, edition_validate.model);

      if (errors.length == 0) {
        bus.$emit("changeLoading", true);

        if (this.tempFile != "") {
          this.edition.file = this.tempFile;
        }

        let promise =
          this.formType == "create"
            ? axios.post(
                `${process.env.VUE_APP_API_HOST}/api/magazine_editions`,
                this.edition
              )
            : axios.put(
                `${process.env.VUE_APP_API_HOST}/api/magazine_editions/${this.edition.id}`,
                this.edition
              );

        promise
          .then(response => {
            bus.$emit("changeLoading", false);
            Swal.fire({
              title:
                this.formType == "create"
                  ? "Nova edição cadastrada"
                  : "Edição alterada com sucesso",
              icon: "success",
              onClose: () => {
                this.$router.push({ name: "admin.editions" });
              }
            });
          })
          .catch(error => {
            bus.$emit("changeLoading", false);
            Swal.fire({
              title: "Ocorreu um erro.",
              icon: "error"
            });
          });
      } else {
        let html = "Preencha todos os campos obrigatórios.";
        if (errors.length < 4) {
          html = "";
          errors.forEach(el => (html += el.message + "<br>"));
        }
        Swal.fire({
          title: "Atenção",
          html: html,
          icon: "warning"
        });
      }
    },
    generateAuthorLetters: function() {
      let promise = axios.get(
        `${process.env.VUE_APP_API_HOST}/api/generate_author_letter/${this.edition.id}`
      );

      promise.then(response => {
        this.authorsLetter = response.data;
        var converted = htmlDocx.asBlob(this.authorsLetter);
        saveAs(converted, "test.docx");
      });
    },
    generateAuthorTags: function() {
      let promise = axios.get(
        `${process.env.VUE_APP_API_HOST}/api/generate_author_tag/${this.edition.id}`
      );

      promise.then(response => {
        this.authorsTag = response.data;
      });
    },
    getMonthLabel: function(value) {
      if (value == "1") return "Janeiro";
      if (value == "2") return "Fevereiro";
      if (value == "3") return "Março";
      if (value == "4") return "Abril";
      if (value == "5") return "Maio";
      if (value == "6") return "Junho";
      if (value == "7") return "Julho";
      if (value == "8") return "Agosto";
      if (value == "9") return "Setembro";
      if (value == "10") return "Outubro";
      if (value == "11") return "Novembro";
      if (value == "12") return "Dezembro";
    }
  }
};
</script>

<style lang="scss">
@import "@/styles/General.scss";
.magazine-edition {
  .card-header {
    background-color: white;
    a {
      text-decoration: none;
      color: $red_primary;
    }
  }
}
</style>